<script setup>
    import { useProjectListStore } from '@/lib/stores/project-list-store';
    import { FilterType } from '@/lib/constants/constants';

    const store = useProjectListStore();

    const props = defineProps({
        firmsTitle: String,
        firmsFilterResult: Object
    });
</script>

<template>
    <div class="col-12">
        <div class="firm-filters">
            <h2 class="lead-classic-large">{{ props.firmsTitle }}</h2>
            <div class="container">
                <div class="row">
                    <div
                        class="firm-by-letter col-12 col-md-4 col-xl-3"
                        v-for="(firms, letterGroup) in props.firmsFilterResult"
                        :key="letterGroup"
                    >
                        <h3 class="fakta">{{ letterGroup.toUpperCase() }}</h3>

                        <div
                            class="input-checkbox-filter"
                            :class="{ active: store.isActiveFilter(firm.id) }"
                            v-for="firm in firms"
                            :key="firm.id"
                            @click.prevent="store.toggleFilter(firm.id, firm.name, FilterType.FIRM)"
                        >
                            <input :id="firm.id" type="checkbox" name="consent" required />
                            <label :for="firm.id">
                                {{ firm.name }}
                                <sub>{{ firm.articleIds.length }}</sub>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
